import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', function() {
    const rtSliders = document.querySelectorAll('.in-swiper');

    rtSliders.forEach((rtSliderEle) => {
        const paginationEl = rtSliderEle.querySelector('.swiper-pagination');

        // find arrows in the closest .insights section
        const parentSection = rtSliderEle.closest('.insights');
        const prevBtn = parentSection.querySelector('.in-arrow-prev');
        const nextBtn = parentSection.querySelector('.in-arrow-next');

        new Swiper(rtSliderEle, {
            slidesPerView: 1,
            spaceBetween: 16,
            loop: true,
            navigation: {
                prevEl: prevBtn,
                nextEl: nextBtn,
            },
            pagination: {
                el: paginationEl,
                clickable: true,
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                },
                767: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                    autoHeight: false,
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 16,
                    autoHeight: true,
                },
            },
        });
    });

});
